var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsExport = function SvgIconsExport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 14a1 1 0 0 1 .993.883L22 15v4a3 3 0 0 1-2.824 2.995L19 22H5a3 3 0 0 1-2.995-2.824L2 19v-4a1 1 0 0 1 1.993-.117L4 15v4a1 1 0 0 0 .883.993L5 20h14a1 1 0 0 0 .993-.883L20 19v-4a1 1 0 0 1 1-1zm-9 2a1 1 0 0 0 .993-.883L13 15V5.415l3.293 3.292a1 1 0 0 0 1.32.083l.094-.083a1 1 0 0 0 .083-1.32l-.083-.094-5-5a1.008 1.008 0 0 0-.112-.097l-.11-.071-.114-.054-.105-.035-.149-.03L12 2l-.075.003-.126.017-.111.03-.111.044-.098.052-.092.064-.094.083-5 5a1 1 0 0 0 1.32 1.497l.094-.083L11 5.415V15a1 1 0 0 0 1 1z",
    fill: "#25253A",
    fillRule: "nonzero"
  }))));
};
export default SvgIconsExport;